// extracted by mini-css-extract-plugin
module.exports = {"loader":"IconSearch_loader__1qlUE","root":"IconSearch_root__3rpUF"};